import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import FontIcon from 'material-ui/FontIcon';
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';
import moment from 'moment';

import { fetchJob } from '../../../actions/jobs';
import { toArray, formatLocation, sortDates } from '../../../utils/helper';
import Dashboard from '../../Dashboard';
import { fetchExceptionsRoutine } from '../../../routines';

import styles from './styles';
import Status from '../../Common/Status/index';

const renderExceptionType = (type = { code: 'Unknown' }) => {
  switch (type.code) {
    case 'MissingItem':
      return <Status label="Missing" containerStyle={{ backgroundColor: 'red' }}/>;
    case 'UnexpectedItem':
      return <Status label="Unexpected" containerStyle={{ backgroundColor: 'red' }}/>;
    default:
      return <Status label="Unknown" containerStyle={{ backgroundColor: 'red' }}/>;
  }
};

class Exceptions extends Component {
  static propTypes = {
    fetchJob: PropTypes.func.isRequired,
    fetchExceptions: PropTypes.func.isRequired,
    job: PropTypes.object.isRequired,
    exceptions: PropTypes.array.isRequired,
    loading: PropTypes.bool,
    dialogs: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
  };

  componentWillMount() {
    const jobId = this.props.match.params.jobId;
    this.loadData(jobId);
  }

  componentWillReceiveProps(newProps) {
    console.log('jobId1',this.props.match.params.jobId, newProps.match.params.jobId);
    if (this.props.match.params.jobId !== newProps.match.params.jobId) {
      this.loadData(newProps.match.params.jobId);
    }
  }

  loadData = (jobId) => {
    this.props.fetchJob(jobId);
    this.props.fetchExceptions({ jobId });
  }

  handleViewException = (exception) => {
    console.log('handleViewException', exception);
  };

  renderException(exception) {
    console.log('exception', exception);

    const unknown = { building: 'Unknown' };
    const origin = exception.task ? exception.task.origin : unknown;
    const destination = exception.task ? exception.task.destination : unknown;
    const exceptionLocation = exception.occurredAt || (exception.task && exception.stage ? exception.task[exception.stage.relativeTo] : unknown);

    return (<TableRow key={exception.id}>
      <TableRowColumn style={styles.itemTypeCol}>{exception.item.type.name}</TableRowColumn>
      <TableRowColumn style={styles.exceptionTypeCol}>{renderExceptionType(exception.type)}</TableRowColumn>
      <TableRowColumn>{formatLocation(origin)}</TableRowColumn>
      <TableRowColumn>{formatLocation(destination)}</TableRowColumn>
      <TableRowColumn>{formatLocation(exceptionLocation)}</TableRowColumn>
      <TableRowColumn style={styles.stageCol}>{exception.stage ? exception.stage.name : ''}</TableRowColumn>
      <TableRowColumn>{exception.created && exception.created.by ? exception.created.by.name : null}</TableRowColumn>
      <TableRowColumn style={styles.dateCol}>{exception.created && exception.created.at ? moment(exception.created.at).format('lll') : null}</TableRowColumn>
      <TableRowColumn><Status label="Open" containerStyle={{ backgroundColor: 'red' }}/></TableRowColumn>
      {/*<TableRowColumn>*/}
        {/*<IconButton*/}
          {/*tooltip="View Details"*/}
          {/*tooltipPosition="bottom-center"*/}
          {/*onClick={() => this.handleViewException(exception)}>*/}
          {/*<FontIcon className="material-icons" style={styles.viewIcon}>search</FontIcon>*/}
        {/*</IconButton>*/}
        {/*<IconButton tooltip="Resolve" tooltipPosition="bottom-center">*/}
          {/*<FontIcon className="material-icons" style={styles.resolveIcon}>check</FontIcon>*/}
        {/*</IconButton>*/}
      {/*</TableRowColumn>*/}
    </TableRow>);
  }

  renderNoData() {
    return (<TableRow key="nodata" selectable={false}>
      <TableRowColumn colSpan={7} style={styles.noDataRow}>
        <FontIcon className="material-icons" style={styles.noData}>tag_faces</FontIcon>
        <div>No exceptions!</div>
      </TableRowColumn>
    </TableRow>);
  }

  render() {
    const { job, exceptions } = this.props;
    const customer = job && job.customer ? job.customer.name : 'Unknown';
    const description = job && job.description ? job.description : '';

    const activeExceptions = (exceptions || []).filter((exception) => !exception.resolved);

    return (
      <Dashboard title={`Exceptions - ${customer} - ${description}`}>
        <Table multiSelectable={false} selectable={false}>
          <TableHeader adjustForCheckbox={false} displaySelectAll={false}>
            <TableRow>
              <TableHeaderColumn style={styles.itemTypeCol}>Item Type</TableHeaderColumn>
              <TableHeaderColumn style={styles.exceptionTypeCol}>Exception Type</TableHeaderColumn>
              <TableHeaderColumn>Origin</TableHeaderColumn>
              <TableHeaderColumn>Intended Destination</TableHeaderColumn>
              <TableHeaderColumn>Exception Location</TableHeaderColumn>
              <TableHeaderColumn style={styles.stageCol}>Stage</TableHeaderColumn>
              <TableHeaderColumn>Created By</TableHeaderColumn>
              <TableHeaderColumn style={styles.dateCol}>Created At</TableHeaderColumn>
              <TableHeaderColumn>Status</TableHeaderColumn>
              {/*<TableHeaderColumn></TableHeaderColumn>*/}
            </TableRow>
          </TableHeader>
          <TableBody displayRowCheckbox={false}>
            { activeExceptions.length > 0 ? activeExceptions.map((exception) => this.renderException(exception)) : this.renderNoData() }
          </TableBody>
        </Table>

        {/* <ViewExceptionDialog open={this.props.dialogs.createJob === true}*/}
        {/* onRequestClose={() => this.hideDialog('createJob')}/>*/}
      </Dashboard>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchJob,
    fetchExceptions: fetchExceptionsRoutine.trigger,
  }, dispatch);
}

function mapStateToProps(state) {
  const job = state.get('jobs').get('job').toJS();

  const exceptions = toArray(state.get('exceptions').get('exceptions').toJS());
  console.log('exc', exceptions);

  return {
    job,
    exceptions: exceptions.sort((a, b) => sortDates(a.created ? a.created.at : new Date(), b.created ? b.created.at : new Date())),
    loading: state.get('jobs').get('loading'),
    dialogs: state.get('dialogs').get('dialogs').toJS(),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Exceptions);



// WEBPACK FOOTER //
// ./src/components/Reports/Exceptions/index.js